import React, {Component} from 'react';
import styled from 'styled-components';
//import Translation from "../dictionary/Translation";
import Button from "../common/Button";
import {mixins} from "../../mixins";
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import * as Actions from "../../actions/actions";
import {toJS} from "../../to-js";
import uuid from 'uuid/v1';
import {priceFormat} from "../../formaters";

const Footer = styled.div`
  padding: 15px;
  padding-top: 20px;
  background-color: ${p => p.theme.cFrameBg};
`;

const Image = styled.div`
  flex-grow: 1;
  padding: 20px 30px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

const InfoRibbon = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const SizeBlock = styled.div`
  display: flex;
  align-items: center;
  font-size: ${p => p.theme.sFontBig}px;
`;

const Size = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  i{
    margin-right: 3px;
    color: ${p => p.theme.cTheme};
  }
  &:last-child{
    margin-right: 0;
  }
`;

const Icon = styled.i`
  display: block;
  font-size: ${p => p.theme.sIcon}px;
`;

const Units = styled.span`
  font-size: ${p => p.theme.sFontRegular}px;
`;

const Price = styled.div`
  font-size: ${p => p.theme.sFontBig}px;
  font-weight: bold;
  
`;

const OrderRibbon = styled.div`
  display: flex;
  align-items: center;
  >*{
    margin-right: 15px;
    &:last-child{
      margin-right: 0;
    }
  }
`;

const InStockBlock = styled.div`
  text-align: center;
  white-space: nowrap;
  min-width: 65px;
  i{
    display: block;
    font-size: ${p => p.theme.sIcon}px;
    margin: auto;
  }
`;

class ProductCard extends Component {
    render() {
        const product = this.props.product;
        return (
            <div className={this.props.className}>
                <Image>
                    <img src={product.image} alt=""/>
                </Image>
                <Footer>
                    <InfoRibbon>
                        <SizeBlock>
                            <Size><Icon
                                className="icon-horizontal-d"/><span>{product.size.x + ' '}<Units>мм</Units></span></Size>
                            <Size><Icon
                                className="icon-vertical-d"/><span>{product.size.y + ' '}<Units>мм</Units></span></Size>
                        </SizeBlock>
                        <Price>
                            {priceFormat(product.price)}
                        </Price>
                    </InfoRibbon>
                    <OrderRibbon>
                        <Button onClick={() => {
                            const id = uuid();
                            this.props.addToCart({
                                id,
                                product_id: product.id,
                                quantity: 1,
                                mods: [],
                            });
                            this.props.openAddToCartModal({
                                id: id,
                                product_id: product.id,
                            })
                        }
                        } fullWidth wireframe label={'в корзину'}/>
                        <InStockBlock>
                            <i className="icon-in-stock"/>
                            2 шт.
                        </InStockBlock>
                    </OrderRibbon>
                </Footer>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        items: state.getIn(['cart', 'items']),
        page: state.getIn(['cart', 'page']),
        addToCartModalOpen: state.getIn(['cart', 'addToCartModalOpen']),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addToCart: Actions.addToCart,
        openAddToCartModal: Actions.openAddToCartModal,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(ProductCard)`
  height: 100%;
  background-color: ${p => p.theme.cWhite};
  display: flex;
  flex-direction: column;
  ${mixins.ease()};
  ${p => p.outline ? 'border: 1px solid ' + p.theme.cFrameBg : ''};
  &:hover, &:focus-within{
    transform: translateY(-5px);
    box-shadow: 0 3px 6px 0 rgba(0,0,0,0.1);
  }
`));